/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * ListRow.tsx
 */

import React from 'react';
import ListAdapter, {AdapterListener} from "./ListAdapter";
import HiloReactComponent from "../view/layout/HiloReactComponent";
import {Entity} from "../model/pagination/Entity";
import {APIPagination} from "../pagination/APIPagination";

interface Props<E extends Entity, L extends AdapterListener<E>, P extends APIPagination> {
    entity: E,
    adapter: ListAdapter<E, L, P>
}

export default class ListRow<E extends Entity, L extends AdapterListener<E>, P extends APIPagination> extends HiloReactComponent<Props<E, L, P>, {}> {

    /**
     * render
     * @returns {any}
     */
    public render(): JSX.Element {
        const e = this.props.entity;
        const adapter = this.props.adapter;

        return <>{adapter.getColumns().map(col =>
            <td key={col.displayKey}
                className={"table-data"}>
                {adapter.getValue(e, col.displayKey)}
            </td>)}
        </>
    }

}